import React, { Component } from 'react';

class Footer extends Component {

    render() {
        return (
            <footer className="footer-container">
            </footer>
        );
    }

}

export default Footer;
